export default function getHashLocationUtil () {
  return window.location.hash || ''
}
